import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as workspaceFeature from 'features/workspaces'

const mapStateToProps = (state: ReduxState) => {
  return {
    workspaceId: workspaceFeature.selectors.activeWorkspaceIdSelector(state)
  }
}

const mapDispatchToProps = {}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
